import { render } from "./IconSuccess.vue?vue&type=template&id=0e0252b1"
import script from "./IconSuccess.vue?vue&type=script&lang=js"
export * from "./IconSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script